<script lang="ts">
  import { focus } from "./actions/focus";
  import DialogBase from "./DialogBase.svelte";
  import { createDrimeConfig } from "./fs";
  import { makeFileSystemDrime, testDrimeConnection } from "./fs-drime";
  import { captureEvent, telegramNotify } from "./http";
  import { showMessage } from "./message";

  interface Props {
    open?: boolean;
    mountfs: (fs: any) => void;
  }

  let { open = $bindable(false), mountfs }: Props = $props();

  let config = $state(createDrimeConfig());
  let testingConnection = $state(false);
  let errorMessage = $state("");

  let canConnect = $derived(config.accessToken.trim() != "" && !testingConnection);

  async function onConnect() {
    testingConnection = true;
    errorMessage = "";
    let removeMsg = showMessage("testing drime connection");
    try {
      config.accessToken = config.accessToken.trim();
      config.name = config.name.trim();
      await testDrimeConnection(config.accessToken);
      if (config.name == "") {
        config.name = "Drime";
      }
      let fs = makeFileSystemDrime(config);
      let who = config.name;
      telegramNotify(`New Drime connection for ${who}`);
      captureEvent("drime-login", {});
      removeMsg();
      mountfs(fs);
      open = false;
    } catch (e) {
      console.error(e);
      errorMessage = (e as Error).toString();
      removeMsg();
    }
    testingConnection = false;
  }

  function close() {
    open = false;
  }
</script>

<DialogBase bind:open title="Connect Drime">
  {#snippet main()}
    <div class="flex flex-col text-sm">
      <label for="input-drime-name">Name: <span class="text-gray-400">(optional)</span></label>
      <input
        use:focus
        type="text"
        id="input-drime-name"
        autocomplete="off"
        class="outline-hidden border px-2 py-1"
        bind:value={config.name}
      />

      <label class="mt-3" for="input-drime-key">Access token:</label>
      <input
        type="password"
        id="input-drime-key"
        autocomplete="off"
        class="outline-hidden border px-2 py-1"
        bind:value={config.accessToken}
      />

      <div class="mt-3 w-72 text-gray-500">
        Make an access token in your
        <a
          href="https://app.drime.cloud/account-settings"
          class="text-blue-600 underline"
          target="_blank"
          rel="noreferrer">Drime account settings</a
        >. <a href="/doc/Drime" class="text-blue-600 underline" target="_blank">More</a>
      </div>

      {#if errorMessage}
        <div class="mt-2 mb-2 w-72 font-medium break-all text-red-500">
          {errorMessage}
        </div>
      {/if}
    </div>
  {/snippet}

  {#snippet bottom()}
    <div class="flex flex-row justify-between">
      <button onclick={close} class="dlg-btn">Cancel</button>
      <button disabled={!canConnect} onclick={onConnect} class="dlg-btn">Connect Drime</button>
    </div>
  {/snippet}
</DialogBase>
